<h1 mat-dialog-title>Associate company role</h1>

<div mat-dialog-content class="dialog-content">
  <div class="user-summary">
    <div class="user-name">{{data.user.firstName}} {{data.user.lastName}}</div>
    <div class="user-email">{{data.user.email || data.user.phoneNumber || data.user.id}}</div>
  </div>

  <form [formGroup]="form" class="form">
    <mat-form-field appearance="outline">
      <mat-label>Company</mat-label>
      <mat-select formControlName="companyId" panelClass="member-addedit-select-search-panel">
        <mat-option [disabled]="true">
          <ngx-mat-select-search
            [formControl]="companySearchControl"
            noEntriesFoundLabel="No companies"
            placeholderLabel="Search companies..."
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let company of filteredCompanies; trackBy: trackByCompanyId" [value]="company.id">
          {{company.name}}<span *ngIf="company.domainName" class="option-secondary"> {{company.domainName}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        <mat-option *ngFor="let role of roleOptions" [value]="role.value">
          {{role.label}}<span class="option-secondary"> {{role.description}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="selectedAssociationExists && !successMessage" class="message error">
      This user already has that role for the selected company.
    </div>
    <div *ngIf="errorMessage" class="message error">{{errorMessage}}</div>
    <div *ngIf="successMessage" class="message success">{{successMessage}}</div>
  </form>

  <div class="associations">
    <div class="section-title">Current company roles</div>
    <table class="associations-table" *ngIf="associations.length > 0">
      <thead>
        <tr>
          <th>Company</th>
          <th>Role</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let association of associations; trackBy: trackByAssociationId">
          <td>
            {{association.companyName}}
            <span *ngIf="association.domainName" class="option-secondary">{{association.domainName}}</span>
          </td>
          <td>{{association.role}}</td>
          <td class="actions-cell">
            <button
              mat-icon-button
              color="warn"
              [disabled]="saving || !!removingAssociationId"
              (click)="removeAssociation(association)"
              matTooltip="Remove role"
            >
              <mat-icon>{{removingAssociationId === association.id ? 'hourglass_empty' : 'delete'}}</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!loading && associations.length === 0" class="empty">No company roles associated yet.</div>
    <div *ngIf="loading" class="empty">Loading...</div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Done</button>
  <button mat-raised-button color="primary" [disabled]="!canSave" (click)="save()">
    {{saving ? 'Saving...' : 'Associate role'}}
  </button>
</div>
